/* eslint-disable max-lines-per-function */
import React from 'react';
export const BasicBlockThreeColumnsPreview = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="287" height="145" viewBox="0 0 287 145">
        <g data-name="Basic block: three columns" transform="translate(-831 -2069)">
            <g fill="#fff" transform="translate(831 2069)">
                <rect width="287" height="145" stroke="none" rx="4" />
                <rect width="286" height="144" x="0.5" y="0.5" fill="none" rx="3.5" />
            </g>
            <text
                fill="#718096"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(1037 2105)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <text
                fill="#728197"
                data-name="copy2"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(952 2105)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                letterSpacing="-.05em"
                transform="translate(855 2117)"
            >
                <tspan x="0" y="10">
                    This is the place{' '}
                </tspan>
                <tspan x="0" y="22">
                    for your content.{' '}
                </tspan>
                <tspan x="0" y="34">
                    Did you know...
                </tspan>
            </text>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                letterSpacing="-.05em"
                transform="translate(940 2117)"
            >
                <tspan x="0" y="10">
                    This is the place{' '}
                </tspan>
                <tspan x="0" y="22">
                    for your content.{' '}
                </tspan>
                <tspan x="0" y="34">
                    Did you know...
                </tspan>
            </text>
            <text
                fill="#a0aec0"
                data-name="copy2"
                fontFamily="Mulish-Regular, Mulish"
                fontSize="10"
                letterSpacing="-.05em"
                transform="translate(1025 2117)"
            >
                <tspan x="0" y="10">
                    This is the place{' '}
                </tspan>
                <tspan x="0" y="22">
                    for your content.{' '}
                </tspan>
                <tspan x="0" y="34">
                    Did you know...
                </tspan>
            </text>
            <text
                fill="#718096"
                data-name="copy2"
                fontFamily="Nunito-SemiBold, Nunito"
                fontSize="12"
                fontWeight="600"
                transform="translate(867 2105)"
            >
                <tspan x="0" y="0">
                    Heading
                </tspan>
            </text>
            <g data-name="Button - Website Primary Button" transform="translate(865 2164)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text fill="#fff" fontFamily="Mulish-Regular, Mulish" fontSize="10" transform="translate(10 17)">
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(950 2164)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text
                    fill="#fff"
                    data-name="Button"
                    fontFamily="Mulish-Regular, Mulish"
                    fontSize="10"
                    transform="translate(10 17)"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
            <g data-name="Button - Website Primary Button" transform="translate(1035 2164)">
                <rect width="50" height="26" fill="#718096" data-name="Button background" rx="4" />
                <text
                    fill="#fff"
                    data-name="Button"
                    fontFamily="Mulish-Regular, Mulish"
                    fontSize="10"
                    transform="translate(10 17)"
                >
                    <tspan x="0" y="0">
                        Button
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
);
